import { useTranslations } from "next-intl"
import styles from "./WindowsPopup.module.css"
import LinkButton, { LinkButtonKind } from "../Buttons/LinkButton/LinkButton"
import Button from "../Buttons/Button/Button"
import { windowsClientDownload } from "@/utils/data"

export default function WindowsPopup({ game, onClose }: { game: any, onClose: () => void }) {

    const t = useTranslations('Modals.WindowsClient')

    return (
        <div className={styles.main} data-testid="WindowsPopup">
            <h2 data-testid="WindowsPopup_title">{t('title')}</h2>
            <div className={styles.buttons} data-testid="WindowsPopup_buttons">
                <LinkButton data-testid="WindowsPopup_downloadLink" kind={LinkButtonKind.SECONDARY} internal={false} href={windowsClientDownload}>{t('download')}</LinkButton>
                <Button onClick={onClose} data-testid="WindowsPopup_playButton">{t('play')}</Button>
            </div>
        </div>
    )
}